import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {HeaderMenuModel} from "./mappers";
import Cookies from "js-cookie";
import HelpModel from "./mappers/models/HelpModel";
import {
  big_card,
  documentation_an_consulting,
  saas_products,
  news_1_img_small_card,
  news_2_img_small_card,
  news_3_img_small_card,
  news_4_img_small_card,
  news_5_img_small_card,
  news_6_img_small_card,
  news_7_img_small_card,
  news_8_img_small_card,
} from "@/shared";

export const useDataStore = defineStore("dataStore", () => {
  const ApiUrl = ref(null);
  const GoogleMapApiKey = ref("AIzaSyBq_kmrNTF3yat6AMbeFfC84fT9haC4k5I");

  /**
   * API url
   * @returns
   */
  const getApiUrl = computed((): string => {
    return ApiUrl.toString();
  });

  /** Возвращает список для header */
  const getHeaderMenu = computed((): Array<HeaderMenuModel> => {
    return new Array<HeaderMenuModel>(
        {Text: "products_and_services", RouterName: "products-services", IsIcon: true},
        {Text: "about_us", RouterName: "about-us", IsIcon: false},
        {Text: "contact_us", RouterName: "contact-us", IsIcon: false},
        {Text: "news", RouterName: "news", IsIcon: false},
    );

  });

  /** Возвращает список для фичи explore-now */
  const getArrExploreNow = computed((): Array<HelpModel> => {
    return new Array<HelpModel>(
        {Text: "saas_products", Image: saas_products, Link: "saas"},
        {Text: "terminal_solutions", Image: big_card, Link: "terminal-solution"},
        {Text: "documentation_an_consulting", Image: documentation_an_consulting, Link: "documentation-consulting"},
    );
  });

  /** Возвращает список для фичи latest-news */
  const getArrLatestNow = (others: boolean = false) => {
        let res = new Array<HelpModel>();
        res.push({Text: "news_1_title", Image: news_1_img_small_card, Link: "news1", Id: 1});
        res.push({Text: "news_2_title", Image: news_2_img_small_card, Link: "news2", Id: 2});
        res.push({Text: "news_3_title", Image: news_3_img_small_card, Link: "news3", Id: 3});
        res.push({Text: "news_4_title", Image: news_4_img_small_card, Link: "news4", Id: 4});
        res.push({Text: "news_5_title", Image: news_5_img_small_card, Link: "news5", Id: 5});
        res.push({Text: "news_6_title", Image: news_6_img_small_card, Link: "news6", Id: 6});
        res.push({Text: "news_7_title", Image: news_7_img_small_card, Link: "news7", Id: 7});
        res.push({Text: "news_8_title", Image: news_8_img_small_card, Link: "news8", Id: 8});
        return res;
      };
  const getShowForm = (name: string, isContactUs: boolean) => {
    let res = false;
    if (isContactUs) {
      if (name == "about-us" || name == "products-services" || name == "documentation-consulting" || name == "contact-us" || name == "saas" || name == "terminal-solution")
        res = true;
    } else {
      if (name == "privacy-policy" || name == "news") res = true;
    }
    return res;
  };

  /** getenerate guid */
  const newGuid = (): string => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
              v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
    );
  };
  /**
   * Получить ключ доступа к google карте
   * @returns
   */
  const getGoogleMapApiKey = (): string => {
    return GoogleMapApiKey.value;
  };
  /**
   * Получить локализацию карты
   * @returns
   */
  const getMapLanguage = (): string => {
    let lac = Cookies.get("culture");
    switch (lac) {
      case "FRA":
        return "fr";
      case "ENG":
        return "en";
      case "RUS":
        return "ru";
      default:
        return "en";
    }
  };

  const scrollTop = () => {
    setTimeout((() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }), 300);
  };

  return {
    getApiUrl,
    getHeaderMenu,
    getArrExploreNow,
    getArrLatestNow,
    scrollTop,
    getGoogleMapApiKey,
    getMapLanguage,
    getShowForm,
    newGuid,
  };
});
